import React from "react"
import { Link } from "gatsby"

import * as style from "./Type.module.scss"

const Type = ({ param, microcopy }) => {
  const isArrayOfUnion = param.type === "array" && ((param.types?.length || 0) + (param.resources?.length || 0) > 1)
  const isUnionOfTypes = param.type === "object" && param.types?.length > 1

  return (
    <span className={style.types}>
      <>
        {param.resource && (
          <Link to={param.resource.path}>{param.resource.title}</Link>
        )}
        {" "}
      </>

      <>
        {!param.resource && param.itemType}
        {' '}
      </>

      <>{isArrayOfUnion && "[ "}</>

      {param.types?.map((type, index) => (
        <React.Fragment key={type}>
          {index > 0 && "/ "}
          {type}
          {" "}
        </React.Fragment>
      ))}

      {param.types && param.resources ? "/ " : ""}

      {param.resources?.map((resource, index) => (
        <React.Fragment key={resource.id}>
          {index > 0 && "/ "}
          <Link to={resource.path}>{resource.title}</Link>
          {" "}
        </React.Fragment>
      ))}

      <>{isArrayOfUnion && "] "}</>

      {param.hasAdditionalProperties && !param.resource && microcopy.text("reference.parameter_types.associative_array")}

      {!param.hasAdditionalProperties && !isUnionOfTypes && param.type}

      {param.format && param.format !== param.type && ` (${param.format})`}
    </span>
  )
}

export default Type
